import Api from '~/config/Api'
const endpoint = Api.packages

export default {
  async fetch (payload = {}, representation = 'minimal') {
    payload.inProgress = true
    const { data } = await useApi(endpoint, {
      params: { ...payload },
      headers: {
        'Accept-Representations': representation
      }
    })

    return data
  },
  async detail (slug) {
    const detailEndpoint = endpoint + '/' + slug
    const { data } = await useApi(detailEndpoint)

    return data
  },
  async availableHotels (
    slug,
    rooms = [],
    checkinDate = undefined,
    checkoutDate = undefined,
    hotelId = undefined,
    venueId = undefined,
    serviceUniqueId = undefined
  ) {
    const cheapestHotelEndpoint =
      endpoint + '/' + slug + '/service-availability/hotels'

    const { data } = await useApi(cheapestHotelEndpoint, {
      method: 'POST',
      body: {
        rooms,
        checkin: checkinDate,
        checkout: checkoutDate,
        idsOrSlugs: [hotelId],
        venueId,
        serviceUniqueId
      }
    })

    return data
  },
  async availableOutwardFlights (
    slug,
    adults = 2,
    children = 0,
    departureDate = undefined,
    isMinimalSearchMode = false,
    maxChanges = 0,
    country = null,
    cities = []
  ) {
    const cheapestHotelEndpoint =
      endpoint + '/' + slug + '/service-availability/outward-flights'

    const { data } = await useApi(cheapestHotelEndpoint, {
      method: 'POST',
      body: {
        adults,
        children,
        departureDate,
        isMinimalSearchMode,
        maxChanges,
        country,
        cities
      }
    })

    return data
  },
  async availableReturnFlights (
    slug,
    adults = 2,
    children = 0,
    departureDate = undefined,
    isMinimalSearchMode = false,
    maxChanges = 0,
    country = null,
    cities = []
  ) {
    const cheapestHotelEndpoint =
      endpoint + '/' + slug + '/service-availability/return-flights'

    const { data } = await useApi(cheapestHotelEndpoint, {
      method: 'POST',
      body: {
        adults,
        children,
        departureDate,
        isMinimalSearchMode,
        maxChanges,
        country,
        cities
      }
    })

    return data
  },
  async serviceAvailabilityAndPrice (
    slug,
    {
      packageId,
      contactInfo,
      passengers,
      services,
      hasInsurance,
      hasMatchInsurance,
      hasAcceptedExtraordinaryConditions,
      hasAcceptedPremiumUpgrade,
      isResidualSaleBooking,
      coupon,
      comment
    }
  ) {
    const serviceAvailabilityAndPriceEndpoint =
      endpoint + '/' + slug + '/service-availability'

    const { data, error } = await useApi(serviceAvailabilityAndPriceEndpoint, {
      method: 'POST',
      body: {
        packageId,
        contactInfo,
        passengers,
        services,
        coupon: coupon?.code,
        extra: {
          hasInsurance,
          hasMatchInsurance,
          hasAcceptedExtraordinaryConditions,
          hasAcceptedPremiumUpgrade,
          isResidualSaleBooking,
          comment
        }
      }
    })

    if (error && error.value) {
      throw error.value
    }

    return data
  }
}
